import Page from "@insite/mobius/Page/";
import { clearfixStyles } from "@store/theme/common/mixins";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(Page.defaultProps, {
    padding: 0,
    fullWidth: [true, true, true, true, true],
    css: css`
        /* Chrome 87 - Fix margin issues - Temporary fix ? */
        ${clearfixStyles()}
    `,
});
